import { Link, useNavigate } from "react-router-dom";
import Icon from "@forwardflow/ui/Icons";
import { SetNewPasswordForm } from "@forwardflow/forms";
import { useState } from "react";
import { Button } from "@forwardflow/ui";

export const SetNewPasswordComponent = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();
  const handleFormSubmit = (values: any) => {
    if (values !== "") {
      setIsSubmitted(true);
    }
  };
  const handleNavigate = () => {
    navigate("/signin");
  };
  return (
    <>
      <div className="flex flex-col items-center justify-center w-full h-screen relative  -translate-y-20">
        <Link
          className="bg-white/10 transition-all hover:bg-white/20 w-[200px] h-12 flexc rounded-full md:absolute mt-7 md:mt-0 top-10 right-4 md:right-16"
          to="/signup"
        >
          Sign up
        </Link>

        <h1 className="text-[22px] font-medium my-7">Set new password</h1>

        <h2 className="text-[12px] md:text-[14px] mb-[50px] text-[#C9C9C9]">
          Create a new password to sign in from now on
        </h2>
        {!isSubmitted ? (
          <SetNewPasswordForm onSubmit={handleFormSubmit} />
        ) : (
          <>
            <div className="w-full max-w-[450px] mx-auto mb-5 bg-black/40 border border-white/20 rounded-xl p-8 flex flex-col justify-center">
              <Icon name="Fingerprint" className="mx-auto mb-5" />
              <h2 className="text-[20px] font-semibold mb-7">
                Password reset successful!
              </h2>
              <div className="text-[14px]">
                <p className="mb-4 text-white/70">
                  Login to your account using new password
                </p>
              </div>
            </div>
            <Button onClick={handleNavigate} className="max-w-[450px]">
              Sign in using new password
            </Button>
          </>
        )}
      </div>
    </>
  );
};
